var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"max-content"}},[_c('a',{staticClass:"d-none d-md-inline",attrs:{"href":"https://diabete.qc.ca"}},[_c('v-img',{attrs:{"src":require("@/assets/logo.jpg"),"contain":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }